import { moveMediaElementZindexTopAction } from 'editor/src/store/design/slice';
import { ElementAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const moveMediaElementZindexTopOperation = (elementAddress: ElementAddress) => (dispatch: ThunkDispatch) =>
  dispatch(moveMediaElementZindexTopAction(elementAddress));

export default moveMediaElementZindexTopOperation;
